var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { align: "center" } },
    [
      _c(
        "v-flex",
        { attrs: { md10: "" } },
        [
          _c(
            "v-card",
            [
              _c(
                "v-container",
                { attrs: { "grid-list-md": "" } },
                [
                  _c(
                    "div",
                    { attrs: { align: "left" } },
                    [
                      _c("v-flex", { attrs: { md12: "" } }, [
                        _c("h2", [
                          _vm._v(
                            "Visualizar y Editar Ingreso Nº" +
                              _vm._s(_vm.numero)
                          )
                        ])
                      ])
                    ],
                    1
                  ),
                  _c("v-divider"),
                  _c("br"),
                  _c(
                    "div",
                    { staticClass: "divContenedor" },
                    [
                      _c(
                        "v-flex",
                        { staticClass: "fle" },
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              label: "Estado",
                              items: ["VIGENTE", "ANULADO"],
                              disabled: !_vm.campoEstadoEditable
                            },
                            on: {
                              change: function($event) {
                                _vm.mostrarConf = true
                              }
                            },
                            model: {
                              value: _vm.inputEstado,
                              callback: function($$v) {
                                _vm.inputEstado = $$v
                              },
                              expression: "inputEstado"
                            }
                          }),
                          _c("modal-confirmacion", {
                            attrs: {
                              show: _vm.mostrarConf,
                              titulo: "¿Está seguro de anular el Ingreso?",
                              mensaje: "Este cambio es irreversible",
                              textoBtnSi: "Continuar",
                              textoBtnNo: "Cancelar",
                              width: 450
                            },
                            on: { modalConfirmationEmit: _vm.responseModal }
                          })
                        ],
                        1
                      ),
                      _c("v-flex", { staticClass: "fle" }),
                      _c("v-flex", { staticClass: "fle" })
                    ],
                    1
                  ),
                  _vm.campoEstadoEditable ? _c("v-divider") : _vm._e(),
                  _vm.campoEstadoEditable ? _c("br") : _vm._e(),
                  _c(
                    "div",
                    { staticClass: "divContenedor" },
                    [
                      _c(
                        "v-flex",
                        { staticClass: "fle" },
                        [
                          _c("v-combobox", {
                            attrs: { label: "Telco", disabled: "", dense: "" },
                            model: {
                              value: _vm.telco,
                              callback: function($$v) {
                                _vm.telco = $$v
                              },
                              expression: "telco"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { staticClass: "fle" },
                        [
                          _c("v-combobox", {
                            attrs: { label: "Plan", disabled: "", dense: "" },
                            model: {
                              value: _vm.plan,
                              callback: function($$v) {
                                _vm.plan = $$v
                              },
                              expression: "plan"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { staticClass: "fle" },
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: "Destino",
                              disabled: "",
                              required: ""
                            },
                            model: {
                              value: _vm.destino,
                              callback: function($$v) {
                                _vm.destino = $$v
                              },
                              expression: "destino"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "divContenedor" },
                    [
                      _c(
                        "v-flex",
                        { staticClass: "fle" },
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: "Cantidad de SIMSs Ingresadas",
                              disabled: "",
                              required: ""
                            },
                            model: {
                              value: _vm.cantSims,
                              callback: function($$v) {
                                _vm.cantSims = $$v
                              },
                              expression: "cantSims"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { staticClass: "fle" },
                        [
                          _c("v-text-field", {
                            attrs: { label: "Usuario", disabled: "" },
                            model: {
                              value: _vm.usuario,
                              callback: function($$v) {
                                _vm.usuario = $$v
                              },
                              expression: "usuario"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { staticClass: "fle" },
                        [
                          _c("DatePicker", {
                            attrs: {
                              label: "Fecha",
                              value: _vm.inputFecha,
                              disabled: ""
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }